import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiEligibleUsersResponseModel } from '@/types'

export const getKpiEligibleUsers =
  async (): Promise<KpiEligibleUsersResponseModel> => {
    try {
      const response = await axios.get(`${BASE_URL}/kpi/eligible-users`, {})

      return response.data
    } catch (error) {
      throw error
    }
  }
